<template>
    <div>
        <div class="columns toolbar-box action-right">
            <div class="column is-3">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Companies</span>
                        <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                    </span>
                </h1>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <autocomplete-select
                        type="company"
                        placeholder="Search by name"
                        v-model="filters.id"
                        @update:modelValue="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <o-input
                        type="search"
                        v-model="filters.city"
                        placeholder="Search by city"
                        icon="search"
                        @change.native="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <o-input
                        type="search"
                        v-model="filters.zip"
                        placeholder="Search by Zip code"
                        icon="search"
                        @change.native="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-5-tablet is-2-desktop action-box">
                <div class="field is-grouped is-grouped-right">
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                    <p class="control">
                        <button @click.prevent="openCompanyModal(null)" class="button is-info" ><span class="icon"><i class="icm-quick-add"></i></span><span>Quick add</span></button>
                    </p>
                    <p class="control">
                        <router-link :to="{ name: 'companies.create' }" class="button is-info" ><span class="icon"><i class="icm-new"></i></span><span>New</span></router-link>
                    </p>
                </div>
            </div>
        </div>
        <merge-duplicates />
        <o-table
            class="fullwidth-table is-responsive is-responsive-desktop"

            v-if="isTableVisible"
            :data="paginatedData"
            v-model:currentPage="currentPage"
            :bordered="table.bordered"
            :striped="table.striped"
            :narrowed="table.narrowed"
            :checkable="table.checkable"
            :mobile-cards="table.mobileCards"
            :paginated="table.paginated"
            :pagination-simple="table.paginationSimple"
            :per-page="table.perPage"
            :default-sort-direction="table.defaultSortDirection"
            :default-sort="table.defaultSort"

            :selected.sync="selected"
            :checked-rows="checkedRows"
             @update:checkedRows="$event => checkedRows = $event"

            :loading="loading"
            :total="total"
            backend-sorting
            backend-pagination
            @page-change="onPageChange"
            @sort="onSort"
        >
            <template>
              <o-table-column
                  v-for="col in tableColumns"
                  v-bind="col"
                  #default="{ row }"
                  :field="col.field"
                  :label="col.field === 'actions' ? '' : col.label"
                  :key="col.field"
                  :sortable="col.sortable"
                  @click.native="openContactsModal(row)"
              >
                <router-link v-if="col.field === 'name'" :to="{ name: 'companies.show', params: { slug: row.id } }">
                  {{ $filters.valueOrDefault(row.name, '–') }}
                </router-link>

                <router-link v-if="col.field === 'last_editor_id'" :to="{ name: 'users.show', params: { slug: row.last_editor_id } }">
                  {{ userNameById(row.last_editor_id) }}
                </router-link>

                <span v-if="col.field === 'email'">{{ row.email }}</span>
                <span v-if="col.field === 'address'">{{ row.address }}</span>
                <span v-if="col.field === 'city'">{{ row.city }}</span>
                <span v-if="col.field === 'state'">{{ row.state }}</span>
                <span v-if="col.field === 'zip'">{{ row.zip }}</span>
                <span v-if="col.field === 'phone'">{{ row.phone }}</span>
                <span v-if="col.field === 'fax'">{{ row.fax }}</span>
                <span v-if="col.field === 'task_based'">{{ $filters.yesNo(row.task_based) }}</span>
                <span v-if="col.field === 'ibm_number'">{{ row.ibm_number }}</span>
                <span v-if="col.field === 'ibm_exp_date'">{{ $filters.valueOrDefault($filters.date(row.ibm_exp_date)) }}</span>
                <span v-if="col.field === 'tax_id'">{{ row.tax_id }}</span>
                <span v-if="col.field === 'hic_license'">{{ row.hic_license }}</span>
                <span v-if="col.field === 'dob_tracking'">{{ row.dob_tracking }}</span>
                <span v-if="col.field === 'dob_tracking_exp_date'">{{ $filters.valueOrDefault($filters.date(row.dob_tracking_exp_date)) }}</span>
                <span v-if="col.field === 'special_inspection_agency'">{{ row.special_inspection_agency }}</span>
                <span v-if="col.field === 'notes'" class="notation" v-html="row.notes"></span>
                <span v-if="col.field === 'created_at'">{{ $filters.datetime(row.created_at) }}</span>
                <span v-if="col.field === 'updated_at'">{{ $filters.datetime(row.updated_at) }}</span>
                <span v-if="col.field === 'lead_owner'">{{ $filters.valueOrDefault(userNameById(row.lead_owner)) }}</span>

                <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                  <template v-slot:trigger>
                    <button class="button">
                      <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                    </button>
                  </template>
                  <o-dropdown-item has-link><a @click.stop.prevent="openContactModal(row)">Add Contact</a></o-dropdown-item>
                  <o-dropdown-item has-link><a @click.stop.prevent="openCompanyModal(row)">Quick Edit</a></o-dropdown-item>
                  <o-dropdown-item has-link><router-link :to="{ name: 'companies.show', params: { slug: row.id } }">View</router-link></o-dropdown-item>
                </o-dropdown>
              </o-table-column>
            </template>

          <template v-slot:empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>

        <div class="columns">
          <div class="column is-5-tablet is-3-desktop page-selector">
            Total: <strong>{{ total }}</strong>
            Goto page:
            <div class="selector">
              <o-input type="number" v-model="selectedPage" min="0" :max="totalPages" @update:modelValue="validatePageInput"/>
              <button @click.prevent="goToPage()" class="button is-info">
                <span>Go</span>
              </button>
            </div>
          </div>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isContactsModalActive" has-modal-card>
            <contacts-modal :company-id="companyId" />
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isComponentModalActive" has-modal-card>
            <contact-modal width="1500" :item="contactItem" :quick-add="true" />
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isCompanyModalActive" class="company-modal" has-modal-card>
            <company-modal :item="currentCompany"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Table from '../../mixins/Table'
    import ContactModal from '../../components/modals/Contact'
    import CompanyModal from '../../components/modals/Company'
    import ContactsModal from '../../components/modals/Contacts'
    import MergeDuplicates from '../../components/merge-duplicates/MergeDuplicates.vue'

    export default {
        mixins: [Table],

        components: {
            ContactModal,
            CompanyModal,
            ContactsModal,
            MergeDuplicates,
        },

        created () {
            this.filters = {
                id: null,
                city: '',
                zip: '',
                state: null
            }
        },

        mounted () {
            this.fetchPaginatedData()

            $('.checkbox-cell').click((e) => {
                e.stopPropagation()
            })
        },

        data () {
            return {
                tableName: 'companies-index',
                companyId: null,
                contactItem: null,
                currentCompany: null,
                isCompanyModalActive: false,
                isContactsModalActive: false,
                isComponentModalActive: false,
                selectedPage: 1,
            }
        },
        methods: {
            ...mapActions({
                fetchData: 'fetchCompanies',
                removeItem: 'removeCompany'
            }),

            openCompanyModal (company) {
                this.isCompanyModalActive = true
                this.currentCompany = company
            },

            openContactModal(company) {
                this.contactItem = {company_id: company.id}
                this.isComponentModalActive = true
            },

            openContactsModal(company) {
                this.companyId = company.id
                this.isContactsModalActive = true
            },
            validatePageInput(e) {
              if (this.selectedPage < 1) {
                this.selectedPage = 1;
                e.preventDefault();
              }
            },
            goToPage() {
              this.onPageChange(this.selectedPage);
              this.currentPage = parseInt(this.selectedPage)
            }
        },

        computed: {
            ...mapGetters(['states', 'userNameById']),

            ...mapGetters({
                itemsByIds: 'companiesByIds'
            }),

            filteredCompanies () {
                return this.companies.filter((company) => {
                    for (let field in this.filters) {
                        let value = ''

                        if (company[field]) {
                            value = company[field].toLowerCase()
                        }

                        let filterValue = this.filters[field].toLowerCase()

                        if (! value.includes(filterValue)) {
                            return false
                        }
                    }

                    return true
                })
            },

            totalPages() {
              return Math.ceil(this.total / this.table.perPage)
            },
        }
    }
</script>
